@file:Suppress("MemberVariableNaming", "TopLevelPropertyNaming", "MatchingDeclarationName")

package screens.list

import common.EConstants
import common.ECssClasses
import components.ButtonContent
import components.Toolbar
import components.alert.Alert
import components.alert.AlertItem
import components.burgerMenu.BurgerMenu
import components.colourToneItem.ColourToneItem
import components.colourToneItem.EColourToneItemLeftButtonType
import components.items.ProductlistIcon
import components.items.WatchlistIcon
import components.items.WatchlistIconProps
import components.toast.BottomToast
import components.toast.ToastItem
import core.AppContext
import core.enums.EImages
import core.enums.EJSBridgeActions
import core.enums.ELocalizationKeys
import core.extensions.isInNativeApp
import core.extensions.postMessageToNativeApp
import core.extensions.toClassName
import core.extensions.useCoroutineScope
import core.io.CustomHttpClient
import core.io.dto.ExternalLinkDTO
import core.io.dto.JSBridgeActionDTO
import core.ionic.IonButton
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonHeader
import core.ionic.IonPage
import core.ionic.IonRow
import core.localStorage.LocalStorageDAO
import core.localization.Localization
import core.piwik.Piwik
import csstype.Display
import csstype.JustifyContent
import csstype.Margin
import csstype.Overflow
import csstype.number
import csstype.pct
import csstype.px
import download
import emotion.react.css
import kotlinx.browser.window
import kotlinx.coroutines.launch
import module.watchlist.ColourListObject
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.Navigate
import react.router.useNavigate
import react.useContext
import react.useState
import screens.EScreens

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 14.10.22
 * Author : mariorosshirt
 */

external interface WatchListScreenProps : Props {
}

val WatchListScreen = FC<WatchListScreenProps> { props ->

    val mContext by useContext(AppContext)

    val (mLocalStorageState, mLocalStorageDispatch) = mContext.mLocalStorageReducer

    val mNavigate = useNavigate()
    var mTargetScreen: String? by useState(null)

    var mToastItem: ToastItem? by useState(null)
    var mAlertItem: AlertItem? by useState(null)

    val mScope = useCoroutineScope()
    val mClient = CustomHttpClient()

    fun deleteFromWatchlist(colour: ColourListObject) {
        mLocalStorageDispatch(
            LocalStorageDAO.ELocalStorageAction.DELETE_FROM_WATCHLIST(
                colour
            )
        ).also {
            mToastItem = ToastItem(
                Localization.getLocalizationKey(
                    ELocalizationKeys.CORE_TOAST_DELETE_FROM_WATCH_LIST
                )
            )
        }
    }

    fun exportWatchList() {
        if (!window.isInNativeApp()) {
            mScope.launch {
                val response = mClient.exportWatchList(mLocalStorageState.mWatchlist)
                response.download(Localization.getLocalizationKey(ELocalizationKeys.EXPORT_FILENAME_WATCHLIST))
            }
        } else {
            val jsBridgeActionDTO = JSBridgeActionDTO(
                EJSBridgeActions.EXPORT_WISHLIST,
                mLocalStorageState.mWatchlist
            )
            window.postMessageToNativeApp(jsBridgeActionDTO)
        }
    }

    fun shareWatchList() {
        if (window.isInNativeApp()) {
            val jsBridgeActionDTO = JSBridgeActionDTO(
                EJSBridgeActions.SHARE_WISHLIST,
                mLocalStorageState.mWatchlist
            )
            window.postMessageToNativeApp(jsBridgeActionDTO)
        }
    }


    BurgerMenu()
    IonPage {
        id = EConstants.BURGER_MENU_CONTENT.mId
        IonHeader {
            Toolbar {
                mEndViews = listOf(FC<WatchlistIconProps> { WatchlistIcon { mIsActive = true } }, ProductlistIcon)
            }
            IonRow {
                IonCol {
                    css {
                        display = Display.flex
                        justifyContent = JustifyContent.spaceBetween
                    }
                    ReactHTML.span {
                        css(ECssClasses.LIST_HEADER_FONT.toClassName()) {}
                        +Localization.getLocalizationKey(ELocalizationKeys.S10_HEADER.name)
                    }
                    ReactHTML.div {
                        css { marginRight = 2.px }
                        if(window.isInNativeApp()){
                            IonButton {
                                fill = "clear"
                                ReactHTML.img {
                                    css {
                                        height = 24.px
                                        display = Display.flex
                                        justifyContent = JustifyContent.spaceBetween
                                    }
                                    src = EImages.SHARE_ICON(EImages.EColor.GRAY).mRelativePath
                                }
                                disabled = mLocalStorageState.mWatchlist.isEmpty()
                                onClick = {
                                    shareWatchList()
                                    Piwik.trackCustomEvent(
                                        Piwik.CATEGORY_WISH_LIST,
                                        Piwik.NAME_WISHLIST_SHARE,
                                        Piwik.NAME_WISHLIST_SHARE
                                    )
                                }
                            }
                        }
                        IonButton {
                            fill = "clear"
                            ReactHTML.img {
                                css {
                                    height = 24.px
                                }
                                src = EImages.DOWNLOAD_ICON(EImages.EColor.GRAY).mRelativePath

                            }
                            disabled = mLocalStorageState.mWatchlist.isEmpty()
                            onClick = {
                                exportWatchList()
                                Piwik.trackCustomEvent(
                                    Piwik.CATEGORY_WISH_LIST,
                                    Piwik.NAME_WISHLIST_DOWNLOAD,
                                    Piwik.NAME_WISHLIST_DOWNLOAD
                                )
                            }
                        }
                    }
                }
            }
        }
        IonContent {
            IonGrid {
                css(ECssClasses.VERTICAL_GRID.toClassName(), ECssClasses.NON_SCROLLABLE_GRID.toClassName()) {}
                IonRow {
                    css() {
                        flexGrow = number(1.0)
                        overflow = Overflow.scroll
                    }
                    IonCol {
                        css() {
                            height = 100.pct
                        }
                        size = "12"

                        mLocalStorageState.mWatchlist.forEach {
                            ColourToneItem() {
                                css() {
                                    minHeight = 112.px
                                }
                                this.mColourObject = it
                                mColourToneItemLeftButtonType = EColourToneItemLeftButtonType.PRODUCT_LIST
                                mColourToneItemLeftButtonToastMessage = { toastItem ->
                                    mToastItem = toastItem
                                }
                                mDeleteFunction = {

                                    if (!mLocalStorageState.mProductList.contains(it)) {
                                        deleteFromWatchlist(it)
                                    } else {
                                        mAlertItem = AlertItem.confirmDeleteAlertItem(
                                            Localization.getLocalizationKey(
                                                ELocalizationKeys.S10_DELETE_CONFIRMATION_TEXT
                                            )
                                        ) {
                                            deleteFromWatchlist(it)
                                        }
                                    }
                                }
                            }
                        }

                        if (mLocalStorageState.mWatchlist.isEmpty()) {
                            ReactHTML.div {
                                css(ECssClasses.LIST_NOTE_STYLE.toClassName()) {}
                                ReactHTML.div {
                                    css(ECssClasses.PRODUCT_CARD_ITEM_MEDIUM_FONT_WEIGHTED.toClassName()) {

                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.S10_WATCH_LIST_EMPTY_TITLE.name)
                                }
                                ReactHTML.div {
                                    css {
                                        marginTop = 8.px
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.S10_WATCH_LIST_EMPTY_TEXT.name)
                                }
                                ReactHTML.div {
                                    css {
                                        display = Display.flex
                                        justifyContent = JustifyContent.center
                                    }

                                    IonButton {
                                        css(ECssClasses.PRIMARY_BUTTON.toClassName()) {
                                            width = 165.px
                                            marginTop = 42.px
                                        }
                                        onClick = {
                                            mTargetScreen = EScreens.COLOUR_FINDER_UPLOAD_SCREEN.mPath
                                        }
                                        ButtonContent {
                                            mContent =
                                                Localization.getLocalizationKey(ELocalizationKeys.S10_WATCH_LIST_EMPTY_BUTTON_CONTENT.name)
                                        }
                                    }
                                }
                            }
                        }
                    }

                    mToastItem?.let {
                        BottomToast {
                            this.mToastItem = it
                        }
                    }

                }
                IonRow {
                    css {
                        margin = Margin(top = 28.px, horizontal = 20.px, bottom = 0.px)
                    }
                    IonCol {
                        css {
                            padding = 0.px
                        }
                        IonButton {
                            css(ECssClasses.PRIMARY_BUTTON.toClassName()) {
                                display = Display.block
                            }
                            disabled = mLocalStorageState.mWatchlist.isEmpty()
                            onClick = {
                                mTargetScreen = EScreens.SELECTABLE_WATCH_LIST_SCREEN.mPath
                            }
                            ButtonContent {
                                mLeftImage = EImages.PAINT_ROLLER_SMALL
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.S10_SHOW_ON_WALL_BUTTON_CONTENT.name)
                            }
                        }
                    }
                }
                IonRow {
                    css(ECssClasses.BOTTOM_BUTTONS.toClassName()) {}
                    IonCol {
                        css {
                            justifyContent = JustifyContent.spaceBetween
                            display = Display.flex
                            padding = 0.px
                        }
                        IonButton {
                            css(ECssClasses.SECONDARY_BUTTON.toClassName()) {
                                width = 165.px

                            }
                            onClick = {
                                mNavigate.invoke(-1)
                            }
                            ButtonContent {
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.CORE_BACK.name)
                            }
                        }
                        IonButton {
                            css(ECssClasses.PRIMARY_BUTTON.toClassName()) {
                                width = 165.px
                            }
                            onClick = {
                                Piwik.trackCustomEvent(
                                    Piwik.CATEGORY_SEARCH,
                                    Piwik.NAME_SEARCH_OPEN_RETAILER,
                                    Piwik.NAME_SEARCH_OPEN_RETAILER
                                )
                                if(!window.isInNativeApp()){
                                    window.open(Localization.getLocalizationKey
                                        (ELocalizationKeys.RETAIL_SEARCH_URL.name))
                                }else{
                                    val jsBridgeActionDTO = JSBridgeActionDTO(
                                        EJSBridgeActions.EXTERNAL_LINK,
                                        ExternalLinkDTO(Localization.getLocalizationKey
                                            (ELocalizationKeys.RETAIL_SEARCH_URL.name))
                                    )
                                    window.postMessageToNativeApp(jsBridgeActionDTO)
                                }
                            }
                            ButtonContent {
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.RETAIL_BUTTON_TITLE.name)
                            }
                        }
                    }
                }

            }
        }
    }
    mTargetScreen?.let {
        Navigate {
            to = it
        }
    }
    mAlertItem?.let {
        Alert {
            this.mAlertItem = it
        }
    }
}